import { Box } from '@material-ui/core';
import { userroles } from '../../../constants';
import useLandingChart from '../../../../hooks/useLandingChart';
import { moneyFormat, getColor } from '../../common/helpers';
import InfoBox from '../InfoBox';

function CashBox({ isRTL, theme, dark, color, systemcolor, height }) {
  const { raseeds } = useLandingChart(null);
  const clr = getColor({ theme, color, systemcolor });
  return (
    <Box>
      {userroles?.sales?.admin && (
        <InfoBox
          title={isRTL ? 'الصندوق' : 'Cash'}
          value={moneyFormat(raseeds?.cash)}
          icon="cash"
          color={clr}
          dark={dark}
          height={height}
        ></InfoBox>
      )}
    </Box>
  );
}

export default CashBox;
